module.exports = __webpack_public_path__ + "fonts/a70186fb-9048-4500-89c9-b0916000381b.75fdcc9d.woff";